import { render, staticRenderFns } from "./DeleteOfficeModal.vue?vue&type=template&id=5c16a23d&"
import script from "./DeleteOfficeModal.vue?vue&type=script&lang=js&"
export * from "./DeleteOfficeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports